import { PipeTransform, Pipe } from '@angular/core';
import { DecimalPipe, CurrencyPipe } from '@angular/common';

@Pipe(
    {
        name: 'money'
    })
export class MoneyPipe implements PipeTransform
{

    private decimalPipe: DecimalPipe = new DecimalPipe('da-DK');
    private currencyPipe: CurrencyPipe = new CurrencyPipe('da-DK');

    public transform(value: number, millionFormat?: boolean, ...args: any[]): string
    {
        // if millionFormat round to the nearest million and displays 'mio'
        if (millionFormat && value >= 100000000)
        {
            return `${this.decimalPipe.transform(Math.round(value / 100000000))} mio kr.`;
        }
        else
        {
            const amount = value / 100;
            const cents = Math.round(100 * (amount % 1));

            if (cents > 0)
            {
                return `${this.currencyPipe.transform(value / 100, 'kr.')}`;
            }

            return `${this.decimalPipe.transform(Math.round(value / 100))} kr.`;
        }
    }
}
